// DailyCardModal - Daily card of the day display
import React from 'react';
import { motion } from 'framer-motion';
import { Modal } from '../common/Modal';
import { TarotCard } from '../tarot/TarotCard';
import { MarkdownText } from '../common/MarkdownText';

export const DailyCardModal = ({ isOpen, onClose, cardData, isLoading }) => {
    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="✨ Your Card for Today ✨"
            isLoading={isLoading && !cardData}
            size="md"
        >
            {cardData?.card ? (
                <motion.div
                    className="flex flex-col items-center text-center py-4"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                >
                    {/* Card Display */}
                    <motion.div
                        initial={{ scale: 0.8, rotateY: -90 }}
                        animate={{ scale: 1, rotateY: 0 }}
                        transition={{
                            type: "spring",
                            damping: 20,
                            delay: 0.2
                        }}
                    >
                        <TarotCard
                            name={cardData.card.name}
                            orientation={cardData.card.orientation}
                            emoji={cardData.card.emoji}
                            isClickable={false}
                        />
                    </motion.div>

                    {/* Interpretation */}
                    <motion.div
                        className="mt-6"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.5 }}
                    >
                        <h4 className="text-lg font-serif text-amber-200 mb-3">
                            Cosmic Guidance for Your Day
                        </h4>
                        <MarkdownText size="base">
                            {cardData.interpretation}
                        </MarkdownText>
                    </motion.div>
                </motion.div>
            ) : (
                !isLoading && (
                    <p className="text-center text-purple-400/70 py-8">
                        Could not unveil the card at this moment. Perhaps the cosmos needs a moment more?
                    </p>
                )
            )}
        </Modal>
    );
};

export default DailyCardModal;
